<button type="button" class="btn btn-primary">
  Single Button
</button>
